/**
 * Privacy filter — strips phone numbers, emails, and social handles
 * from any user-generated message content before display or storage.
 */

const PATTERNS: RegExp[] = [
  // Email addresses
  /[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}/g,
  // SA phone numbers (various formats)
  /(\+27|0)[0-9\s\-().]{8,14}/g,
  // Generic phone-like sequences
  /\b0[6-8][0-9][\s\-]?[0-9]{3}[\s\-]?[0-9]{4}\b/g,
  // WhatsApp / Telegram mentions
  /\bwhatsapp\b/gi,
  /\btelegram\b/gi,
  // URLs
  /https?:\/\/[^\s]+/gi,
  /www\.[^\s]+/gi,
  // Social handles
  /@[a-zA-Z0-9_]{2,}/g,
];

const REPLACEMENT = '[contact info removed]';

export function filterPrivateInfo(text: string): string {
  let result = text;
  for (const pattern of PATTERNS) {
    result = result.replace(pattern, REPLACEMENT);
  }
  return result;
}

export function containsPrivateInfo(text: string): boolean {
  return PATTERNS.some((p) => {
    p.lastIndex = 0;
    return p.test(text);
  });
}
